import { Translate } from 'next-translate';

import { sanitizeNumericInput } from '@utils/table-renderers/sanitizeNumericInput';

import { messageBlank, messageInvalid } from './validateMessages';

export type FieldTypes = 'array' | 'number' | 'string | number' | 'string';

const validatePresenceOf = (
  t: Translate,
  prefix: string,
  obj: Record<string, any>,
  parent: string,
  fieldType: [string, FieldTypes],
): void => {
  if (!obj || !fieldType) return;
  const [field, type] = fieldType;
  const value = obj[field];

  if (type === 'string' && !value?.trim()?.length) {
    throw new Error(`${prefix}: ${messageBlank(t, parent, field)}`);
  }

  if (type === 'number') {
    const number = sanitizeNumericInput(value);

    if (number === '' || number <= 0) {
      throw new Error(`${prefix}: ${messageInvalid(t, parent, field)}`);
    }

    if (!number) {
      throw new Error(`${prefix}: ${messageBlank(t, parent, field)}`);
    }
  }

  if (type === 'array' && !Array.isArray(value)) {
    throw new Error(`${prefix}: ${messageBlank(t, parent, field)}`);
  }

  if (type === 'string | number' && !value) {
    throw new Error(`${prefix}: ${messageBlank(t, parent, field)}`);
  }
};

export const validatesPresenceOf = (
  t: Translate,
  prefix: string,
  obj: Record<string, any>,
  parent: string,
  fields: Record<string, FieldTypes>,
): void => {
  if (!obj || obj?._destroy || !Object.keys(fields)?.length) return;

  Object.entries(fields).forEach((field: [string, FieldTypes]): void => {
    validatePresenceOf(t, prefix, obj, parent, field);
  });
};
